//
// TextFieldOptions
//
// Field options for type 'text'

import { observer } from 'mobx-react-lite'

import { duckField } from '../../../../stores/data/validators'
import { InitialFieldOption } from './InitialFieldOption'
import { TextLengthFieldOptions } from './TextLengthFieldOptions'

export const TextFieldOptions = observer(function TextFieldOptions({
    field,
    selectModified,
    worksheet,
    onAction,
    setSelected,
    renderkeyprefix,
}) {
    if (!field) return null
    const min_length = field.options.get('min_length')
    const max_length = field.options.get('max_length')

    const duckInitialField = duckField(field.type, {
        min_length: min_length,
        max_length: max_length,
    })

    return (
        <>
            <InitialFieldOption
                field={field}
                initialField={duckInitialField}
                selectModified={selectModified}
                worksheet={worksheet}
                onAction={onAction}
                setSelected={setSelected}
                renderkeyprefix={renderkeyprefix}
            />
            <TextLengthFieldOptions
                field={field}
                selectModified={selectModified}
                worksheet={worksheet}
                onAction={onAction}
                setSelected={setSelected}
                renderkeyprefix={renderkeyprefix}
            />
        </>
    )
})
